/**
 * Customer-facing order status labels for Heritage HQ.
 *
 * Internal stage names (used by Heritage staff in /console) MUST NOT leak
 * into the customer portal. This helper translates internal stages into
 * warm, on-brand language with a soft subtitle for each.
 */
export const HQ_STATUS_MAP = {
  // Awaiting payment
  awaiting_payment:        { label: "Awaiting Payment", subtitle: "Just waiting on your payment to confirm your order.", tone: "amber" },
  unpaid:                  { label: "Awaiting Payment", subtitle: "Just waiting on your payment to confirm your order.", tone: "amber" },

  // Inventory / preparation
  awaiting_inventory:      { label: "Processing",        subtitle: "Heritage is preparing your blooms.", tone: "lilac" },
  inventory_assigned:      { label: "Being Prepared",    subtitle: "Your tubers are with the packers.", tone: "lilac" },
  assigned:                { label: "Being Prepared",    subtitle: "Your tubers are with the packers.", tone: "lilac" },
  confirmed:               { label: "Being Prepared",    subtitle: "Your tubers are with the packers.", tone: "lilac" },
  finalised:               { label: "Ready To Ship",     subtitle: "Boxed up and ready, awaiting collection.", tone: "olive" },
  ready_to_ship:           { label: "Ready To Ship",     subtitle: "Boxed up and ready, awaiting collection.", tone: "olive" },

  // Shipping
  shipping:                { label: "On Its Way",        subtitle: "Picked up by the courier , on the way to you.", tone: "teal" },
  in_transit:              { label: "On Its Way",        subtitle: "Picked up by the courier , on the way to you.", tone: "teal" },
  delivery:                { label: "Out For Delivery",  subtitle: "On Kayla's local run , hand delivered to your door.", tone: "teal" },

  // QC / Delivered / Completed
  quality_control:         { label: "Delivered",         subtitle: "Arrived safely , Heritage is just checking in.", tone: "green" },
  delivered:               { label: "Delivered",         subtitle: "Arrived safely.", tone: "green" },
  completed:               { label: "Complete",          subtitle: "All wrapped up. Thank you for choosing Heritage.", tone: "ink" },

  // Edge cases
  refunded:                { label: "Refunded",          subtitle: "A refund has been processed.", tone: "ink" },
  cancelled:               { label: "Cancelled",         subtitle: "This order was cancelled.", tone: "ink" },
};

const DEFAULT = { label: "In Progress", subtitle: "Your order is being looked after.", tone: "lilac" };

export function hqStatus(internalStage, paymentStatus) {
  if (paymentStatus === "paid" && (internalStage === "awaiting_payment" || internalStage === "unpaid")) {
    return HQ_STATUS_MAP.awaiting_inventory;
  }
  return HQ_STATUS_MAP[(internalStage || "").toLowerCase()] || DEFAULT;
}

export const HQ_STATUS_TONES = {
  amber: { bg: "#FBF6E9", ink: "#C2622E", border: "#C2622E" },
  lilac: { bg: "var(--hq-soft, #F2EAF3)", ink: "#7B4F82", border: "#7B4F82" },
  olive: { bg: "#F1EEDF", ink: "#5E6E3A", border: "#5E6E3A" },
  teal:  { bg: "#E5F0EE", ink: "#3A6E66", border: "#3A6E66" },
  green: { bg: "#E8EFE2", ink: "#3F5F2F", border: "#3F5F2F" },
  ink:   { bg: "#EFEAEA", ink: "#3E2346", border: "#3E2346" },
};
